<!-- コンテンツ詳細画面 -->
<template>
  <div v-if="!isPreview">
    <HeaderComponent />
  </div>
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="apiErrorMessage" class="error-message">
        {{ apiErrorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isCategoryIdFetched" id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <!-- パンくずリスト -->
        <BreadcrumbsComponent
          v-if="isCategoryIdFetched && !isPreview"
          :title="contentsData.title"
          :categoryId="contentsData.categoryId"
        />

        <div class="com_utl1">
          <div>
            <span class="com_date1 roboto">{{
              contentsData.keisaiKikanStart
            }}</span>
            <span class="com_category1">{{
              contentsData.subCategoryName
            }}</span>
            <span v-if="contentsData.newFlg" class="com_new1 roboto">NEW</span>
          </div>
          <div v-if="!isPreview">
            <a
              v-if="isKaunetAdmin"
              href="#"
              @click.prevent="
                copyContents(contentsData.categoryId, contentsData.contentsId)
              "
              class="com_s_button1"
            >
              <span class="text">
                <span class="text__item">参照新規</span>
                <span class="text__item" aria-hidden="true">参照新規</span>
              </span>
            </a>
            <a
              v-if="isKaunetAdmin"
              href="#"
              @click.prevent="
                editContents(contentsData.categoryId, contentsData.contentsId)
              "
              class="com_s_button2"
            >
              <span class="text">
                <span class="text__item">修正</span>
                <span class="text__item" aria-hidden="true">修正</span>
              </span>
            </a>
            <span
              v-if="contentsData.isFavorite"
              class="com_favorite1 selected"
              @click="handleToggleFavorite(contentsData)"
            ></span>
            <span
              v-else
              class="com_favorite1"
              @click="handleToggleFavorite(contentsData)"
            ></span>
          </div>
        </div>
        <!-- エラーメッセージの表示エリア -->
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        <h1 class="com_d_title1">{{ contentsData.title }}</h1>

        <div v-if="contentsData.contentsVideoList.length > 0">
          <div>{{ contentsData.contentsVideoList[0].videoExp }}</div>
          <div :class="containerClass">
            <VideoPlayer
              v-for="(videoData, index) in contentsData.contentsVideoList"
              :key="videoData.rowNo"
              :videoSrc="`/${videoData.videoPath}/${videoData.videoName}`"
              :contentsId="contentsData.contentsId"
              screenName="コンテンツ詳細"
              :class="playerClass(index)"
              @half-watched="handleHalfWatched"
            />
          </div>
        </div>
        <div class="ql-editor" v-html="sanitizedContent"></div>

        <div v-if="isExistsLinkAreaItem" class="com_links1">
          <div v-if="contentsData.contentsLinkList.length > 0" class="item1">
            <div>
              <h3>リンク</h3>
            </div>
            <div>
              <ul
                v-for="link in contentsData.contentsLinkList"
                :key="link.rowNo"
                class="list1"
              >
                <li>
                  <a
                    v-if="isInternalLink(link.url)"
                    :href="`${link.url}`"
                    class="com_link1"
                    @click="regLinkClick(link.url)"
                    >{{ link.caption || link.url }}</a
                  >
                  <a
                    v-else
                    :href="`${link.url}`"
                    class="com_link1"
                    target="_blank"
                    @click="regLinkClick(link.url)"
                    >{{ link.caption || link.url }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="contentsData.contentsTempFileList.length > 0"
            class="item1"
          >
            <div>
              <h3>文書ファイル</h3>
              <a
                href="#"
                class="com_dl_button1"
                @click.prevent="
                  downloadFiles(
                    contentsData.categoryId,
                    contentsData.contentsId,
                    ''
                  )
                "
                ><span>全データダウンロード</span></a
              >
            </div>
            <div>
              <ul
                v-for="tmpFile in contentsData.contentsTempFileList"
                :key="tmpFile.rowNo"
                class="list2"
              >
                <li>
                  <a
                    href="#"
                    class="com_link1"
                    target="_blank"
                    @click.prevent="
                      downloadFiles(
                        contentsData.categoryId,
                        contentsData.contentsId,
                        tmpFile.tempFileName
                      )
                    "
                    >{{ tmpFile.tempFileName }}</a
                  ><span v-if="tmpFile.tempFileSize" class="sub1">
                    ({{ tmpFile.tempFileSize }})</span
                  ><a
                    href="#"
                    class="com_dl_button2"
                    @click.prevent="
                      downloadFiles(
                        contentsData.categoryId,
                        contentsData.contentsId,
                        tmpFile.tempFileName
                      )
                    "
                    ><span>ダウンロード</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          v-if="contentsData.contentsImgList.length > 0"
          class="com_d_content1"
        >
          <div
            v-for="imgFile in contentsData.contentsImgList"
            :key="imgFile.rowNo"
          >
            <img
              :src="`/${imgFile.imgPath}/${imgFile.imgName}`"
              :alt="imgFile.imgExp"
            />
          </div>
        </div>
        <div v-if="!isPreview" style="text-align: center">
          <span v-if="isSkilupCategory">
            <div class="com_check_comp2">
              <input
                type="checkbox"
                id="checkComplete"
                name=""
                :value="isWatched"
                @change="updateWatchedStatus()"
                :checked="isWatched"
              />
              <label for="checkComplete">完了</label>
            </div>
          </span>
        </div>
        <a
          v-if="!isPreview && !isModal"
          href="#"
          class="com_b_button1"
          @click.prevent="goback"
        >
          <span class="text">
            <span class="text__item">戻る</span>
            <span class="text__item" aria-hidden="true">戻る</span>
          </span>
        </a>
        <a
          v-if="!isPreview && isModal"
          href="#"
          class="com_b_button1"
          @click.prevent="frmClose"
        >
          <span class="text">
            <span class="text__item">閉じる</span>
            <span class="text__item" aria-hidden="true">閉じる</span>
          </span>
        </a>
      </div>
    </section>
  </div>
  <div v-if="!isPreview">
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop v-if="!isPreview" />
</template>

<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, ref, onMounted, computed, PropType } from "vue";
import VideoPlayer from "../controls/VideoPlayer.vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import BreadcrumbsComponent from "../layout/BreadcrumbsComponent.vue";
import { useRouter } from "vue-router";
import { goBackToPreviousUrl } from "@/router";
import {
  outputDebugLogs,
  formatMessage,
  toggleFavoritePage,
  scrollToTop,
  getTargetDate,
  regRecentlyViewedHistory,
  isTokenAlive,
  sanitizeInput,
  regLinkClickLog,
  regFileLinkClickLog,
  commonHandleAxiosError,
} from "@/Common";
import { useProcessingStore } from "../../store/useProcessingStore";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";
import apiAuthClient from "@/util/apiClientAuth";
import apiDownloadClient from "@/util/apiClientDownload";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useUserParmitionStore } from "@/store/userParmitionStore";

// ContentsLinkListModel
interface ContentsLinkListModel {
  rowNo: number;
  caption: string;
  url: string;
}

// ContentsVideoListModel
interface ContentsVideoListModel {
  rowNo: number;
  videoExp: string;
  videoPath: string;
  videoName: string;
}

// ContentsTempFileListModel
interface ContentsTempFileListModel {
  rowNo: number;
  tempFileExp: string;
  tempFilePath: string;
  tempFileName: string;
  tempFileSize: string;
}

// ContentsImgListModel
interface ContentsImgListModel {
  rowNo: number;
  imgExp: string;
  imgPath: string;
  imgName: string;
}

// Main Data Model
interface DataModel {
  categoryId: string;
  categoryName: string;
  subCategoryId: string;
  subCategoryName: string;
  contentsId: string;
  title: string;
  keisaiKikanStart: string;
  keisaiKikanEnd: string;
  newFlg: boolean;
  jyuyoFlg: boolean;
  lastUpdate: string;
  contentsBody: string;
  contentsLinkList: ContentsLinkListModel[];
  contentsVideoList: ContentsVideoListModel[];
  contentsTempFileList: ContentsTempFileListModel[];
  contentsImgList: ContentsImgListModel[];
  isFavorite: boolean;
  updateFormPath: string;
}

export default defineComponent({
  name: "ContentsDetailComponent",
  components: {
    VideoPlayer,
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    BackToTop,
  },
  props: {
    categoryId: {
      type: String as PropType<string>,
      required: true,
    },
    contentsId: {
      type: String as PropType<string>,
      required: true,
    },
    isPreview: {
      type: Boolean as PropType<boolean>,
    },
    ismodal: {
      type: Boolean as PropType<boolean>,
    },
  },
  setup(props) {
    const videoPlayers = ref([]);
    const router = useRouter();
    const processingStore = useProcessingStore(); //状態管理ストア
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const errorMessage = ref(""); // エラーメッセージ
    const apiErrorMessage = ref(""); // エラーメッセージ（ページの真ん中にでるやつ）
    const isCategoryIdFetched = ref(false); // カテゴリIDが取得済みかどうかを追跡
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const serchCategoryId = ref(""); //検索用 カテゴリID
    const serchContentsId = ref(""); //検索用 コンテンツID
    const isPreviewMode = ref(false);
    const { logoutUser } = useUserStore();
    const sanitizedContent = ref(""); //サニタイジングされた本文
    const skilupCategoryId = ref<string | null>(null); // スキルアップのカテゴリID
    const isSkilupCategory = ref(false); // お知らせカテゴリかどうかのフラグ
    const { getCategoryIdByName } = useUserParmitionStore();
    const isWatched = ref(false); // 視聴済フラグ
    const isModal = ref(false);

    /**
     * コンテンツデータの定義
     */
    const contentsData = ref<DataModel>({
      categoryId: "",
      categoryName: "",
      subCategoryId: "",
      subCategoryName: "",
      contentsId: "",
      title: "",
      keisaiKikanStart: "",
      keisaiKikanEnd: "",
      newFlg: false,
      jyuyoFlg: false,
      lastUpdate: "",
      contentsBody: "",
      contentsLinkList: [],
      contentsVideoList: [],
      contentsTempFileList: [],
      contentsImgList: [],
      isFavorite: false,
      updateFormPath: "",
    });

    /**
     * 初期表示処理
     */
    onMounted(async () => {
      outputDebugLogs("プロパティのカテゴリID: " + props.categoryId);
      outputDebugLogs("プロパティのコンテンツID " + props.contentsId);
      outputDebugLogs("パラメータのモーダルフラグ " + props.ismodal);

      outputDebugLogs("プレビューか： " + props.isPreview);

      isPreviewMode.value = props.isPreview || false;
      serchCategoryId.value = props.categoryId;
      serchContentsId.value = props.contentsId;
      isModal.value = props.ismodal || false;
      try {
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // コンテンツ詳細取得API
        const response = await apiAuthClient.post(
          "/api/ContentsDetail/getContentsDetail",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: serchCategoryId.value,
            contentId: serchContentsId.value,
            targetDate: getTargetDate(""),
          }
        );

        // レスポンスからコンテンツ詳細データを取得
        const data = response.data;
        contentsData.value = data;

        // 本文をサニタイジングする
        sanitizedContent.value = sanitizeInput(contentsData.value.contentsBody);

        // 閲覧履歴登録
        regRecentlyViewedHistory(
          agCode.value,
          userId.value,
          serchCategoryId.value,
          serchContentsId.value
        );

        // スキルアップのカテゴリIDを取得
        skilupCategoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_SKILLUP
        );

        isSkilupCategory.value =
          skilupCategoryId.value == serchCategoryId.value;

        // スキルアップの場合は視聴履歴を取得する
        if (isSkilupCategory.value == true) {
          // スキルアップ視聴履歴登録・削除API
          const skilupRes = await apiAuthClient.post(
            "/api/SkilUp/GetWatchStatus",
            {
              systemKbn: process.env.VUE_APP_SYSTEM_KBN,
              userId: serchUserId.value,
              agCode: serchAgCode.value,
              categoryId: serchCategoryId.value,
              contentsId: serchContentsId.value,
              isWatched: false,
            }
          );

          isWatched.value = skilupRes.data.isWatched;
        }

        isCategoryIdFetched.value = true; // カテゴリIDが取得されたことを設定
        isInitError.value = false;
      } catch (error: unknown) {
        isInitError.value = true;
        // エラー時は初期表示エラーフラグをON
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 403:
              // 取得件数オーバー
              apiErrorMessage.value = messages.ERR_0022;
              break;
            default:
              // その他のエラー
              apiErrorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      }
    });

    /**
     * リンクエリアのデータが存在するか
     */
    const isExistsLinkAreaItem = computed(() => {
      return (
        contentsData.value.contentsLinkList.length > 0 ||
        contentsData.value.contentsTempFileList.length > 0
      );
    });

    /**
     * 動画が1件か複数か
     */
    const containerClass = computed(() => {
      return contentsData.value.contentsVideoList.length === 1
        ? "single-video"
        : "multiple-videos";
    });

    /**
     * ビデオプレイヤーの動的スタイル
     * @param index 動画のインデックス
     */
    const playerClass = (index: number) => {
      const videoCount = contentsData.value.contentsVideoList.length;
      const isOdd = videoCount % 2 !== 0;
      if (isOdd && index === videoCount - 1) {
        return "full-width";
      }
      return videoCount > 1 ? "half-width" : "full-width";
    };

    // お気に入り登録・解除
    const toggleFavorite = async (item: DataModel) => {
      // isProcessingがtrueなら処理をスキップ
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;
      try {
        outputDebugLogs("コンテンツID：" + item.contentsId);

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        //お気に入り登録・解除
        const result = await toggleFavoritePage(
          item.categoryId,
          item.contentsId,
          item.isFavorite,
          "コンテンツ詳細画面"
        );

        if (!result) {
          errorMessage.value = formatMessage(
            messages.ERR_SYS003,
            item.isFavorite ? "お気に入り登録" : "お気に入り解除"
          );
        }

        // 状態を更新
        item.isFavorite = !item.isFavorite;
      } catch (error) {
        outputDebugLogs("Error toggling favorite:" + error);
      } finally {
        await new Promise((resolve) => setTimeout(resolve, 500));
        processingStore.isProcessing = false;
      }
    };

    const handleToggleFavorite = (item: DataModel) => {
      if (!processingStore.isProcessing) {
        toggleFavorite(item);
      }
    };

    /** 戻る処理 */
    const goback = () => {
      // もとの画面に戻る処理
      goBackToPreviousUrl();
    };

    const handleHalfWatched = () => {
      outputDebugLogs("A video has been watched halfway.");
    };

    const frmClose = () => {
      // もとの画面に戻る処理
      window.close();
    };

    /**
     * コンテンツ編集
     * コンテンツ登録画面に編集モードで遷移します
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const editContents = (ctgyId: string, ctsId: string) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);
        outputDebugLogs(
          "contentsData.value.updateFormPath: " +
            contentsData.value.updateFormPath
        );

        // コンテンツ登録画面へ編集モードで遷移
        router.push({
          path: "/" + contentsData.value.updateFormPath,
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * コンテンツコピー
     * コンテンツ登録画面に参照新規モードで遷移します
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const copyContents = (ctgyId: string, ctsId: string) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);
        outputDebugLogs(
          "contentsData.value.updateFormPath: " +
            contentsData.value.updateFormPath
        );

        // コンテンツ登録画面へ参照新規モードで遷移
        router.push({
          path: "/" + contentsData.value.updateFormPath,
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_COPY,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const downloadFiles = async (
      ctgyId: string,
      ctsId: string,
      flName: string
    ) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post("/api/download", {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          userId: userId.value,
          agCode: agCode.value,
          categoryId: ctgyId,
          contentId: ctsId,
          fileName: flName,
          targetDate: getTargetDate(""),
          pseudoUserId: pseudoUserId.value,
          pseudoAgCode: pseudoAgCode.value,
          screenName: "コンテンツ詳細",
        });

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /** 引数で渡されたURLが内部リンクか外部リンクかを判定します */
    const isInternalLink = (url: string): boolean => {
      try {
        // ベースURLのホスト名を正規表現で取得
        const baseUrl = process.env.VUE_APP_CLIENT_BASE_URL;
        const baseHostMatch = baseUrl.match(
          /^https?:\/\/([^/?#]+)(?:[/?#]|$)/i
        );

        if (!baseHostMatch) {
          return false;
        }
        const baseHost = baseHostMatch[1];

        // URLが相対パスであるか、ベースURLと同じホスト名を持つ場合は内部リンク
        const internalLinkPattern = new RegExp(
          `^(\\/|(?:https?:\\/\\/)?${baseHost}(?:[/:?#]|$))`,
          "i"
        );
        return internalLinkPattern.test(url);
      } catch (error) {
        outputDebugLogs("error" + error);
        return false;
      }
    };

    /**
     * リンククリックのログを出力します
     * @param linkUrl リンクURL
     */
    const regLinkClick = (linkUrl: string) => {
      regLinkClickLog(
        linkUrl,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        contentsData.value.contentsId,
        "コンテンツ詳細"
      );
    };

    /**
     * ファイルリンククリックのログを出力します
     * @param fileName ファイル名
     */
    const regFileLinkClick = (fileName: string) => {
      regFileLinkClickLog(
        fileName,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        contentsData.value.contentsId,
        "コンテンツ詳細"
      );
    };

    /**
     * 視聴完了制御
     */
    const updateWatchedStatus = async () => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        isWatched.value = !isWatched.value;
        console.log("Updated isWatched:", isWatched.value);

        // スキルアップ視聴履歴登録・削除API
        const response = await apiAuthClient.post(
          "/api/SkilUp/skilupWatchHistoryReg",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: serchCategoryId.value,
            contentsId: serchContentsId.value,
            isWatched: isWatched.value,
          }
        );

        console.log("skilupWatchHistoryReg:", response.status);
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
      scrollToTop();
    };

    return {
      videoPlayers,
      containerClass,
      playerClass,
      goback,
      isProcessing: processingStore.isProcessing,
      handleHalfWatched,
      isKaunetAdmin,
      contentsData,
      errorMessage,
      handleToggleFavorite,
      editContents,
      copyContents,
      isCategoryIdFetched,
      isExistsLinkAreaItem,
      downloadFiles,
      isInternalLink,
      apiErrorMessage,
      isInitError,
      isPreviewMode,
      sanitizedContent,
      regLinkClick,
      regFileLinkClick,
      isSkilupCategory,
      isWatched,
      updateWatchedStatus,
      isModal,
      frmClose,
    };
  },
});
</script>

<style scoped>
.video-container {
  width: 100%;
  margin-bottom: 20px;
}

.single-video .video-container {
  width: 100%;
}

.multiple-videos .video-container {
  float: left;
}

.half-width {
  width: 48%;
}

.full-width {
  width: 100%;
}

.half-width:nth-child(odd) {
  margin-right: 4%;
}

.multiple-videos {
  display: flex;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .half-width,
  .full-width {
    width: 100%;
    margin-right: 0;
  }
}

.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
</style>

<style></style>
